import { BCMSRecord, BCMSRecordProperty } from "@bcm-dev/bcms-vite";
import { PositivePayCheckFile } from "model";
/**
* @class PositivePayCheckFileRow
* @classdesc Class definition for record type from model
* @param {OBJECT} record - record from model to init class
* @property {STRING} _id - The account of the check.
* @extends BCMSRecord
* @example const record = model.positivePayCheckFileRos[0];
* const profile = new PositivePayCheckFileRow(record);
*/
export default class PositivePayCheckFileRow extends BCMSRecord {
    _id
    _positivePayCheckFile
    _mapColumn1
    _mapColumn2
    _mapColumn3
    _mapColumn4
    _mapColumn5
    _mapColumn6
    _mapColumn7
    _mapColumn8

    constructor(record) {     
      super(record) 
    }
  }
  PositivePayCheckFileRow.define({
    "recordType": "positivePayCheckFileRows",
    "recordIDProp":"id",
    "className" : "PositivePayCheckFileRow",
    "recordProperties":[
      /** 
       * @name id
       * @instance
       * @property get {STRING} - gets the id
       * @property set {STRING} - sets the id
       * @memberof PositivePayCheck
       */
      BCMSRecordProperty.mapToString("id","_id"),
      BCMSRecordProperty.mapToClass("positivePayCheckFile", "_positivePayCheckFile", () => PositivePayCheckFile),
      BCMSRecordProperty.mapToString("mapColumn1", "_mapColumn1"),
      BCMSRecordProperty.mapToString("mapColumn2", "_mapColumn2"),
      BCMSRecordProperty.mapToString("mapColumn3", "_mapColumn3"),
      BCMSRecordProperty.mapToString("mapColumn4", "_mapColumn4"),
      BCMSRecordProperty.mapToString("mapColumn5", "_mapColumn5"),
      BCMSRecordProperty.mapToString("mapColumn6", "_mapColumn6"),
      BCMSRecordProperty.mapToString("mapColumn7", "_mapColumn7"),
      BCMSRecordProperty.mapToString("mapColumn8", "_mapColumn8"),

    ]  
})




